import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import '../assets/css/common.css';
import logo from '../assets/images/murata-logo.png';
import { registrationCheckService } from '../services/registrationCheckService';

export default function Layout() {
  const role = Number(localStorage.getItem('userRole'));
  const isAdmin = [1,2,3].includes(role);
  const [isOnboarding, setIsOnboarding] = React.useState(false);

  React.useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const r = await registrationCheckService.checkRegistration();
        const complete = !!(r?.hasMemberData && r?.hasRouteData && r?.hasPhotoData && r?.hasConfidentialityData);
        if (mounted) setIsOnboarding(!complete);
      } catch (e) {
        // 安全側に倒す: 取得失敗時はナビを隠す
        if (mounted) setIsOnboarding(true);
      }
    };
    load();
    return () => { mounted = false; };
  }, []);

  return (
    <div className="app-shell">
      <header className="header">
        <div className="header-container">
          <div className="logo">
            <img className="logo-img" src={logo} alt="Murata Logo" />
          </div>
          {!isOnboarding && (
            <nav className="nav">
              <Link to="/" className="nav-link">マイページ</Link>
              {isAdmin && <Link to="/member-list" className="nav-link">メンバー一覧</Link>}
            </nav>
          )}
        </div>
      </header>
      <main style={{ maxWidth: 1200, margin: '96px auto 40px', padding: '0 16px' }}>
        <Outlet />
      </main>
    </div>
  );
}
